import { Link } from 'react-router-dom'

import styled from 'styled-components';

const NormalLink = styled(Link)`
    border: 1px solid #999999;
    text-decoration: none;
    color: #666666;
    vertical-align: bottom;
    line-height: 30px;
    height: 30px;
    padding: 0 20px;
    text-align: center;
    font-size: x-small;
`;


export default NormalLink
